import React, { useState } from 'react'

import MeleeModal from 'components/meleeModal';

import { Image, Button, Icon } from 'semantic-ui-react';


import fyllamelee_qr from './fyllamelee_qr.png'

const VippsQRModal = () => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Button onClick={() => setOpen(true)}
                basic
                icon className='melee'
                labelPosition='left'
                size='big'
            >
                <Icon name='heart' />
                Support with Vipps
            </Button>

            <MeleeModal
                open={open}
                setOpen={setOpen}
                header='Support with Vipps'
            >
                <div style={{ textAlign: 'center' }}>
                    <Image
                        centered
                        size='medium'
                        src={fyllamelee_qr}
                    />
                    <h3>
                        #768590
                    </h3>
                </div>
            </MeleeModal>
        </>


    )
}

export default VippsQRModal;